import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { BlockableDiv } from '../../../../shared/controls/blockable-div/blockable-div.component';
import { BaseDetailComponent } from '../../../../common/base-detail.component';
import { AddressContactLink } from '../../../../generated/generated-types';
import { DataProtectionWidgetComponent } from '../data-protection-widget/data-protection-widget.component';

@Component({
  selector: 'app-formly-contact-data-protection-widget',
  templateUrl: './formly-contact-data-protection-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ButtonModule,
    BlockableDiv,
    TooltipModule,
    DataProtectionWidgetComponent,
    TranslatePipe,
  ]
})
export class FormlyContactDataProtectionWidgetComponent extends FieldType {

  isSaving: boolean = false;

  constructor(
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  checkIfCanSave() {
    const component = this.options.formState.detailComponent as BaseDetailComponent<AddressContactLink>;

    const anyValue: boolean = this.hasNonNullValue(component.detailForm.value);

    return (component.detailForm.invalid || !anyValue);
  }

  async saveToUnlockEditMode() {

    //Other options would be to use the service, but special overwrite in the component wont be used then

    let component = this.options.formState.detailComponent as BaseDetailComponent<AddressContactLink>;
    if (!component) {
      console.error("No detail component found to save Asset");
      return;
    }

    this.isSaving = true;
    this.cdRef.detectChanges();

    await component.save();

    this.isSaving = false;
    this.cdRef.detectChanges();
  }

  hasNonNullValue(obj: any): boolean {
    // Check if the current level is not an object or is null, which is the base case for recursion.
    if (obj == null || typeof obj !== 'object') {
      return obj != null;
    }

    // Iterate over each property in the object.
    for (const key of Object.keys(obj)) {
      // If the current property is an object, recursively check its properties.
      if (typeof obj[key] === 'object') {
        if (this.hasNonNullValue(obj[key])) {
          return true; // Return true as soon as a non-null value is found.
        }
      } else if (obj[key] != null) {
        return true; // Non-null and non-object value found.
      }
    }

    // If no non-null value was found, return false.
    return false;
  }

}
